import {ReactElement} from 'react';
import {Wrapper, Title, SecondaryText, List, ListItem, Dot} from './styled';

type Props = {
  title: string;
  subtitle: string;
  reasons?: string[];
  icon: ReactElement;
  className?: string;
};
function UnavailableFeature({title, subtitle, reasons, icon, className}: Props) {
  if (!reasons) return null;
  return (
    <Wrapper className={className}>
      <Title className="kiosko:text-kiosko-xl">{title}</Title>
      <div>{icon}</div>
      <SecondaryText className="kiosko:text-kiosko-m kiosko:leading-[48px]">
        {subtitle}
      </SecondaryText>
      <List className="no-access-feature__list">
        {reasons?.map((reason, index) => (
          <ListItem className="no-access-feature__reason-item" key={index}>
            <Dot />
            {reason}
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
}

export {UnavailableFeature};
